import { values } from './enums'

const DueDateQuarterly = {
  FROM_START: 0,
  TILL_END: 1,
  PAST_END: 2
}

const VALUES = values(DueDateQuarterly)

export {
  DueDateQuarterly,
  VALUES
}



// WEBPACK FOOTER //
// ./src/enums/DueDateQuarterly.js